import { UserService } from 'src/app/angularJS/services/user/user.service';
import { TransportLocationService } from 'src/app/angularJS/services/transport-location/transport-location.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';

/**
 * Handles all actions for operator service model creation and editing
 */
export class OperatorServiceFormController {
  private static $inject = [
    '$translate',
    'userService',
    'LinkBuilder',
    'QueryBuilder',
    '$q',
    'transportLocationService',
    '$scope'
  ];

  public currentLocale: string;
  public schemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public model: InterACT.Interfaces.TransportOperatorServices.TransportOperatorService;
  public operator: InterACT.Interfaces.TransportOperators.TransportOperator;
  public startDate: Date;
  public endDate: Date;
  public aliases: Array<string>;
  public selectedSchemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public selectedStartPoint: InterACT.Interfaces.TransportLocations.TransportLocation | string;
  public selectedEndPoint: InterACT.Interfaces.TransportLocations.TransportLocation | string;
  public startPointSearchText: string = '';
  public endPointSearchText: string = '';

  constructor(
    private $translate: ng.translate.ITranslateService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private $q: ng.IQService,
    private transportLocationService: TransportLocationService,
    $scope
  ) {
    // tslint:disable-next-line: forin
    for (const propertyName in $scope.vm) {
      this[ propertyName ] = $scope.vm[ propertyName ];
    }
    this.activate();
  }

  /**
  * Sets the default properties for form fields
  */
  private activate() {
    this.currentLocale = this.$translate.use();
    this.schemes = [];
    this.selectedSchemes = [];
    this.userService.schemes.forEach((scheme) => {
      this.operator.schemes.forEach((operatorScheme) => {
        const operatorSchemeId = operatorScheme.link.split('/').pop();
        if (scheme.id === operatorSchemeId) {
          this.schemes.push(scheme);
        }
      });

      if (this.model.schemes) {
        this.model.schemes.forEach((operatorScheme) => {
          if (operatorScheme.abbreviation === scheme.reference) {
            this.selectedSchemes.push(scheme);
          }
        });
      }
    });

    if(this.model.startPoint){
      if(this.model.startPoint.includes("/transport-locations/")){
        this.transportLocationService.getTransportLocation(this.model.startPoint.split('/').pop()).then(transportLocation => {
        this.selectedStartPoint = transportLocation;
        });
      } else {
        this.selectedStartPoint = this.model.startPoint;
      }
    }

    if(this.model.endPoint){
      if(this.model.endPoint.includes("/transport-locations/")){
        this.transportLocationService.getTransportLocation(this.model.endPoint.split('/').pop()).then(transportLocation => {
        this.selectedEndPoint = transportLocation;
      });
      } else {
        this.selectedEndPoint = this.model.endPoint;
      }
    }
  }

  /**
  * A method that updates the selected startPoint and endPoint location on the transport operator service
  */
  public updateSelected = (fieldName: string) => {
    if (fieldName === 'startPoint') {
      if (!this.selectedStartPoint) {
        this.model.startPoint = undefined;
        return;
      }
      if (!this.model.startPoint) {
        this.model.startPoint = undefined;
      }
      this.model.startPoint = this.linkBuilder.getTransportLocationLink((<InterACT.Interfaces.TransportLocations.TransportLocation>this.selectedStartPoint).id);
    } else {
      if (!this.selectedEndPoint) {
        this.model.endPoint = undefined;
        return;
      }
      if (!this.model.endPoint) {
        this.model.endPoint = undefined;
      }
      this.model.endPoint = this.linkBuilder.getTransportLocationLink((<InterACT.Interfaces.TransportLocations.TransportLocation>this.selectedEndPoint).id);
    }
  }

  /**
    * A method that gets the text that should be displayed for a transport location
    */
  public getLocationText = (transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) => {
    const locationName = transportLocation.locationName;

    if (transportLocation.references) {
      if ((<any>transportLocation.references).atcoCode) {
        return (<any>transportLocation.references).atcoCode + ' - ' + locationName;
      }

      if ((<any>transportLocation.references).naptanCode) {
        return (<any>transportLocation.references).naptanCode + ' - ' + locationName;
      }
    }

    return locationName;
  }

  /**
   * A method that retrieves the transport locations that satisfy the supplied location name
   * @param searchText the name of the location to search for
   */
  public getTransportLocations = (searchText: string) => {
    const deferred = this.$q.defer();
    const schemeLink = this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id);
    const builder = this.queryBuilder.newParam()
      .openSubQuery()
      .fieldIs('scheme.link', schemeLink)
      .or()
      .fieldIs('scheme.link', '/globalScheme')
      .closeSubQuery();

    if (searchText) {
      builder.and().openSubQuery()
        .fieldContains('references.atcoCode', searchText)
        .or().fieldContains('references.naptanCode', searchText)
        .or().fieldContains('locationName', searchText)
        .closeSubQuery();
    }

    const query = builder.getParam();

    this.transportLocationService.getList(1, 1000, query).then((response) => {
      deferred.resolve(response.transportLocations);
    });

    return deferred.promise;
  }
}
